export function getNoteStatus(onlySelectable = false) {
	if (onlySelectable) return ["new", "in_progress"];

	return ["new", "in_progress", "done", "closed", "cancelled"];
}

export function formatNoteStatus(status) {
	if (status === "new") return "Brouillon";
	else if (status === "in_progress") return "En cours";
	else if (status === "done") return "Terminée";
	else if (status === "closed") return "Archivée";
	else if (status === "cancelled") return "Annulée";

	return status;
}

export function getNoteColorFromStatusLabel() {
	return "black";
}

export function getColorFromStatusLabel() {
	return "black";
}

export function getNoteIconNameFromStatusLabel(status) {
	if (status === "new") return "paused";
	else if (status === "in_progress") return "play_arrow";
	else if (status === "done") return "check";
	else if (status === "closed") return "check";
	else if (status === "cancelled") return "stop";
	else return "paused";
}

export function isSiteMonitoringNoteTerminated(state) {
	return state === "done" || state === "closed";
}

export function getIconNameFromStatusLabel(status) {
	if (status === "template") return "stop";
	else if (status === "draft") return "stop";
	else if (status === "wait_valid") return "stop";
	else if (status === "open") return "paused";
	else if (status === "pending") return "paused";
	else if (status === "pre-closed") return "play_arrow";
	else if (status === "closed") return "stop";
	else if (status === "cancelled") return "stop";
	else return "stop";
}

export function formatStatus(status) {
	if (status === "template") return "Modèle";
	else if (status === "draft") return "Brouillon";
	else if (status === "wait_valid") return "En attente de validation";
	else if (status === "open") return "Ouvert";
	else if (status === "pending") return "A renouveler";
	else if (status === "pre-closed") return "Garantie";
	else if (status === "closed") return "Clôturé";
	else if (status === "cancelled") return "Annulé";

	return status;
}

export function getStateColor(status) {
	if (status === "template") return "";
	else if (status === "draft") return "";
	else if (status === "wait_valid") return "waiting-status-color";
	else if (status === "open") return "";
	else if (status === "pending") return "";
	else if (status === "pre-closed") return "in-progress-status-color";
	else if (status === "closed") return "ok-status-color";
	else if (status === "cancelled") return "";

	return status;
}

export function isSiteMonitoringTerminated(state) {
	return state === "closed";
}
